export function stopEvent(event: MouseEvent): void {
  event.stopPropagation();
  event.preventDefault();
}
